import SendMessage from "./message";

export const customFetch = async (url, options = {}) => {
  const token = sessionStorage.getItem("token");
  const tenant = sessionStorage.getItem("tenant");
  const storedBaseUrl = sessionStorage.getItem("baseUrl");
  const baseUrl = getSafeBaseUrl(storedBaseUrl);

  const defaultHeaders = {
    Accept: "application/json",
  };

  if (
    options.body &&
    !(options.body instanceof FormData) &&
    !options.headers?.["Content-Type"]
  ) {
    defaultHeaders["Content-Type"] = "application/json";
  }

  if (token) {
    defaultHeaders.Authorization = `Bearer ${token}`;
  }

  const headers = {
    ...defaultHeaders,
    ...options.headers,
  };

  const response = await fetch(baseUrl + url.replace("{tenant}", tenant), {
    ...options,
    headers,
  });

  if (response.status === 401) {
    if (!options._retry) {
      SendMessage({ status: "token-refresh" });
      return new Promise((resolve) => {
        const handleTokenUpdate = () => {
          window.removeEventListener("token_updated", handleTokenUpdate);
          resolve(customFetch(url, { ...options, _retry: true }));
        };
        window.addEventListener("token_updated", handleTokenUpdate);
      });
    }
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("tenant");
    SendMessage({ status: "token-refresh" });
    throw new Error("Unauthorized");
  }

  if (!response.ok) {
    let errorData = {};
    const contentType = response.headers.get("content-type");

    if (contentType && contentType.includes("application/json")) {
      try {
        errorData = await response.json();
      } catch (e) {
        errorData = {};
      }
    } else {
      try {
        errorData.message = await response.text();
      } catch (e) {
        errorData.message = `Request failed with status ${response.status}`;
      }
    }

    throw new Error(
      errorData.message || `Request failed with status ${response.status}`,
    );
  }

  if (response.status === 204) {
    return null;
  }

  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/json")) {
    return response.json();
  }
  return response.text();
};

function getSafeBaseUrl(baseUrl) {
  if (!baseUrl) {
    return "";
  }

  try {
    const parsedBaseUrl = new URL(baseUrl);
    const currentHostname = window.location.hostname;
    const baseHostname = parsedBaseUrl.hostname;
    const currentIsLoopback = ["localhost", "127.0.0.1", "::1"].includes(
      currentHostname,
    );
    const baseIsLoopback = ["localhost", "127.0.0.1", "::1"].includes(
      baseHostname,
    );

    if (baseIsLoopback && !currentIsLoopback) {
      return "";
    }
  } catch {
    return baseUrl;
  }

  return baseUrl;
}
